import type { MessageDto } from "../api/types";

const MEDIA = new Set(["image", "video", "audio", "document", "sticker"]);

/**
 * Whether a message can go to another chat (the server applies the same rule): not a reaction,
 * not one the contact deleted or whose content was removed, and a file only once it is stored.
 */
export function canForward(m: MessageDto): boolean {
  const content = (m.content ?? {}) as Record<string, unknown>;
  if (
    m.type === "reaction" ||
    m.status === "deleted" ||
    content.purged === true
  )
    return false;
  if (MEDIA.has(m.type)) return m.media?.status === "stored";
  if (m.type === "contacts") return Array.isArray(content.contacts);
  if (m.type === "location") return Boolean(content.location);
  if (m.type === "system" || m.type === "unsupported") return false;
  const text = m.body ?? (typeof content.text === "string" ? content.text : "");
  return Boolean(text.trim());
}

/**
 * WhatsApp Web keeps a forward button beside photos, videos, files, voice notes, stickers,
 * cards and places; text goes through the menu.
 */
export function forwardShortcut(m: MessageDto): boolean {
  return (
    canForward(m) &&
    (MEDIA.has(m.type) || m.type === "contacts" || m.type === "location")
  );
}

/** Every message the team can remove: anything shown, except reactions (they sit on others). */
export function canRemove(m: MessageDto): boolean {
  return m.type !== "reaction" && !m.hidden;
}
